class CountDownTimer {
	constructor() {
		this.variables();
		this.bindEvents();
		this.startCountdown();
	}

	variables() {
		this.countdownContainer = $('#countdown-timer');
		this.countdownDate = this.countdownContainer.data('date');
	}

	bindEvents() {
	}

	startCountdown() {
		this.countdownContainer.countdown(this.countdownDate*1000, function (event) {
			$(this).html(event.strftime('<span class="days">%D<br/><span class="sub-name">DNI</span></span> <span class="hours">%H<br/><span class="sub-name">UR</span></span><span class="minutes">%M<br/><span class="sub-name">MIN</span></span><span class="seconds">%S<br/><span class="sub-name">SEK</span></span>'));
		});
	}

}